<template>
	<div class="app-schema-panel">
		<Panel
			class="app-schema-panel__panel"
			collapsed
			toggleable>
			<template #header>
				<span class="app-schema-panel__title">JSON Schema</span>
				<div class="app-schema-panel__copy-button">
					<Button
						v-tooltip.bottom="'Copy JSON schema'"
						icon="fal fa-paste"
						rounded
						severity="secondary"
						text
						@click="copyJsonSchema" />
				</div>
			</template>
			<pre>{{ JSON.stringify(app.toPOJO(), null, 4) }}</pre>
		</Panel>
	</div>
</template>

<script setup lang="ts">
import type { Build } from '@/models/Build/Model'
import type { EnrichedApp } from '@codecannon/schemas/schemas/EnrichedApp'
import { useToast } from 'primevue'
import Panel from 'primevue/panel'
import Button from 'primevue/button'

const props = defineProps<{
	build: Build
	app: EnrichedApp
}>()

const toast = useToast()

function copyJsonSchema() {
	navigator.clipboard.writeText(JSON.stringify(props.app.toPOJO(), null, 2))
	toast.add({
		severity: 'info',
		summary: 'JSON Schema copied',
		life: 3000,
	})
}
</script>

<style lang="scss" scoped>
.app-schema-panel {
	.app-schema-panel__panel {
		:deep(.p-panel-header) {
			padding: 6px 6px 6px 14px;
		}
		:deep(.app-schema-panel__title) {
			flex: 1;
		}
		:deep(.p-panel-content) {
			overflow: scroll;
			font-size: 6px;
		}
	}
}
</style>
